module.exports = __webpack_public_path__ + "static/Hexagon-59a83558a099a009158ce2c1ca852b35.pdf";